<template>
  <div v-show="state!=='unloaded'" class="text-center align-middle">
  <div class="circle-loader justify-content-center" :class="{'load-complete': state==='loaded'}">
      <div v-show="state==='loaded'" class="checkmark draw"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'bigCheck',
  props: ['state'],
  data () {
    return {};
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Modules/Misc/bigCheck.vue